import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin.js';

export default {
    transitions: {},

    init() {
        gsap.registerPlugin(ScrollTrigger);
        gsap.registerPlugin(DrawSVGPlugin);
        let mm = gsap.matchMedia();
        mm.add('(min-width: 1027px)', () => {
            this.setTriggers();
            this.setupTransitions();

            this.dsmLoopTl = this.loopDSM();
            this.attackLoopTl = this.loopAttack();
            this.realEnvLoopTlArray = this.loopRealEnv();
            //this.loopFirewall();
            this.remediationLoopTl = this.loopRemediation();
            this.remediationLoopTl.pause();
        });

    },

    setTriggers() {
        let lastEl = null;
        $('[data-ctem-trigger]').each((i, el) => {
            let options = {
                trigger: el,
                start: 'top 50%',
                end: '+=1',
                onEnter: () => this.gotTo($(el).data('ctem-trigger')), //markers: true,
            };
            if (i !== 0) {
                const lastElCopy = lastEl;
                options.onEnterBack = () => this.gotTo($(lastElCopy).data('ctem-trigger'));
            }
            ScrollTrigger.create(options);
            lastEl = el;
        });

        // gsap.to('.scroll-bar-box', {
        //     top: '100%', scrollTrigger: {
        //         trigger: '.ctem-content-col', start: 'top center', end: 'bottom-=200 center', scrub: .75,
        //     }, ease: 'none',
        // });
    },

    setupTransitions() {
        this.transitions = gsap.timeline({paused: true})
            .addLabel('top')
            .add(this.transSolution1())
            .addLabel('solution-1')
            .add(this.transSolution2())
            .addLabel('solution-2')
            .add(this.transSolution3())
            .addLabel('solution-3')
            .add(this.transSecurityOverview())
            .addLabel('security-overview')
            .add(this.transSecurityTop())
            .addLabel('security-top')
            .add(this.transSecurityBottom())
            .addLabel('security-bottom')
            .add(this.transVendor())
            .addLabel('vendor')
            .add(this.transRemediation())
            .addLabel('remediation')
            .add(this.transSummery())
            .addLabel('summery');
    },

    gotTo(frameName) {
        this.setActiveBar(frameName);
        this.transitions.tweenTo(frameName, {duration: 2});
    },

    setActiveBar(frameName) {
        $('.ctem-content-active-bar').removeClass('active');
        $('[data-ctem-trigger="' + frameName + '"]').addClass('active');
    },

    grayscale(filterEl, val, brightness) {
        return gsap.timeline()
            .to(filterEl.find('feColorMatrix')[0], {attr: {values: val}})
            .to(filterEl.find('feFuncR')[0], {attr: {slope: brightness}}, 0)
            .to(filterEl.find('feFuncG')[0], {attr: {slope: brightness}}, 0)
            .to(filterEl.find('feFuncB')[0], {attr: {slope: brightness}}, 0)
            ;
    },

    transSolution1() {
        //hide labels
        //zoom
        //grey out all but solutions
        //activate Attack Surface
        return gsap.timeline({
            onStart: () => {
                this.dsmLoopTl.pause();
                this.attackLoopTl.pause();
                this.realEnvLoopTlArray.map(tl => tl.pause());
            }, onReverseComplete: () => {
                this.dsmLoopTl.play();
                this.attackLoopTl.play();
                this.realEnvLoopTlArray.map(tl => tl.play());
            },
        })
            .to('#ctem-svg .labels', {autoAlpha: 0})
            .to('#ctem-svg', {attr: {viewBox: '0 0 540 595'}}, '-=.5')
            .add(this.grayscale($('#filter-real-env'), 0, 1), '-=.5')
            .add(this.grayscale($('#filter-real-env-icons'), 0, 4), '<')
            .add(this.grayscale($('#filter-data-layer'), 0, 1), '<')
            .add(this.grayscale($('#filter-vendor-arrows'), 0, 1), '<')
            .add(this.grayscale($('#filter-vendor-layer'), 0, 1.1), '<')
            .add(this.grayscale($('#filter-firewall-layer'), 0, 1.3), '<')
            .add(this.grayscale($('#filter-attack-layer'), 0, 0.9), '<')
            .add(this.grayscale($('#filter-exposures-layer'), 0, 1.5), '<')
            .add(this.grayscale($('#filter-security-line'), 0, 7), '<')
            .to('#ctem-svg .solution-1 .solution-box', {scale: 1.1, transformOrigin: '0% 72%'})
            .to('#ctem-svg .solution-2 .solution-box', {scale: .9, transformOrigin: '50% 72%'}, '<')
            .to('#ctem-svg .solution-3 .solution-box', {scale: .9, transformOrigin: '100% 72%'}, '<')
            .add(this.grayscale($('#filter-solution-2'), 0, 3), '<')
            .add(this.grayscale($('#filter-solution-3'), 0, 3), '<')
            .to('#ctem-svg .solution-1 .solution-textbox', {y: -10}, '<')
            .to('#ctem-svg .solution-1 .solution-textbox rect', {stroke: '#E01D8D'}, '<');
    },

    transSolution2() {
        //deactivate solution-1
        //activate solution-2
        return gsap.timeline()
            .to('#ctem-svg .solution-1 .solution-box', {scale: .9, transformOrigin: '0% 72%'})
            .to('#ctem-svg .solution-1 .solution-textbox', {y: 0}, '<')
            .to('#ctem-svg .solution-1 .solution-textbox rect', {stroke: '#005da1'}, '<')
            .add(this.grayscale($('#filter-solution-1'), 0, 3), '<')
            .to('#ctem-svg .solution-2 .solution-box', {scale: 1.1, transformOrigin: '50% 72%'})
            .add(this.grayscale($('#filter-solution-2'), 1, 1), '<')
            .to('#ctem-svg .solution-2 .solution-textbox', {y: -10}, '<')
            .to('#ctem-svg .solution-2 .solution-textbox rect', {stroke: '#E01D8D'}, '<');
    },

    transSolution3() {
        //deactivate solution-2
        //activate solution-3
        return gsap.timeline()
            .to('#ctem-svg .solution-2 .solution-box', {scale: .9, transformOrigin: '50% 72%'})
            .to('#ctem-svg .solution-2 .solution-textbox', {y: 0}, '<')
            .to('#ctem-svg .solution-2 .solution-textbox rect', {stroke: '#005da1'}, '<')
            .add(this.grayscale($('#filter-solution-2'), 0, 3), '<')
            .to('#ctem-svg .solution-3 .solution-box', {scale: 1.1, transformOrigin: '100% 72%'})
            .add(this.grayscale($('#filter-solution-3'), 1, 1), '<')
            .to('#ctem-svg .solution-3 .solution-textbox', {y: -10}, '<')
            .to('#ctem-svg .solution-3 .solution-textbox rect', {stroke: '#E01D8D'}, '<');
    },

    transSecurityOverview() {
        //deactivate solution-3
        //fade out solutions
        //fade in the three security layers and dots
        //play purple bar pulse
        return gsap.timeline({
            onComplete: () => {
                this.dsmLoopTl.play();
                this.attackLoopTl.play();
            }, onReverseComplete: () => {
                this.dsmLoopTl.pause();
                this.attackLoopTl.pause();
            },
        })
            .to('#ctem-svg .solution-3 .solution-box', {scale: 1, transformOrigin: '100% 72%'})
            .to('#ctem-svg .solution-2 .solution-box', {scale: 1, transformOrigin: '50% 72%'}, '<')
            .to('#ctem-svg .solution-1 .solution-box', {scale: 1, transformOrigin: '0% 72%'}, '<')
            .to('#ctem-svg .solution-3 .solution-textbox', {y: 0}, '<')
            .to('#ctem-svg .solution-3 .solution-textbox rect', {stroke: '#005da1'}, '<')
            .to('#ctem-svg .solutions circle', {fill: '#A1A1A1'}, '<')
            .add(this.grayscale($('#filter-solution-3'), 0, 3), '<')
            .add(this.grayscale($('#filter-solution-2'), 0, 3), '<')
            .add(this.grayscale($('#filter-solution-1'), 0, 3), '<')
            .add(this.grayscale($('#filter-security-line'), 1, 1))
            .add(this.grayscale($('#filter-firewall-layer'), 1, 1), '<')
            .add(this.grayscale($('#filter-attack-layer'), 1, 1), '<')
            .add(this.grayscale($('#filter-exposures-layer'), 1, 1), '<');
    },

    transSecurityTop() {
        //fade out bottom security
        return gsap.timeline()
            .add(this.grayscale($('#filter-firewall-layer'), 0, 1.3));
    },

    transSecurityBottom() {
        //fade out top security
        //fade in bottom security
        return gsap.timeline({
            onStart: () => {
                this.dsmLoopTl.pause();
            }, onReverseComplete: () => {
                this.dsmLoopTl.play();
            },
        })
            .add(this.grayscale($('#filter-firewall-layer'), 1, 1))
            .add(this.grayscale($('#filter-exposures-layer'), 0, 1.5), '<');
    },

    transVendor() {
        //fade out security
        //fade in vendor and real ENV
        return gsap.timeline({
            onStart: () => {
                this.attackLoopTl.pause();
                this.realEnvLoopTlArray.map(tl => tl.play());
            }, onReverseComplete: () => {
                this.attackLoopTl.play();
                this.realEnvLoopTlArray.map(tl => tl.pause());
            },
        })
            .add(this.grayscale($('#filter-security-line'), 0, 7))
            .add(this.grayscale($('#filter-firewall-layer'), 0, 1.3), '<')
            .add(this.grayscale($('#filter-attack-layer'), 0, 0.9), '<')
            .add(this.grayscale($('#filter-real-env'), 1, 1), '-=0')
            .add(this.grayscale($('#filter-real-env-icons'), 1, 1), '<')
            .add(this.grayscale($('#filter-data-layer'), 1, 1), '<')
            .add(this.grayscale($('#filter-vendor-arrows'), 1, 1), '<')
            .add(this.grayscale($('#filter-vendor-layer'), 1, 1), '<');
    },

    transRemediation() {
        //fade out vendor
        //fade in Solutions
        //fade in arrows and remediation box
        return gsap.timeline({
            onStart: () => {
                //this.realEnvLoopTlArray.map(tl => tl.pause());
                this.remediationLoopTl.play();
            }, onReverseComplete: () => {
                //this.realEnvLoopTlArray.map(tl => tl.play());
                this.remediationLoopTl.pause();
            },
        })
            .add(this.grayscale($('#filter-data-layer'), 0, 1), '<')
            .add(this.grayscale($('#filter-vendor-arrows'), 0, 1), '<')
            .add(this.grayscale($('#filter-vendor-layer'), 0, 1.1), '<')
            .add(this.grayscale($('#filter-solution-3'), 1, 1), '<')
            .add(this.grayscale($('#filter-solution-2'), 1, 1), '<')
            .add(this.grayscale($('#filter-solution-1'), 1, 1), '<')
            .to('#ctem-svg .solutions circle', {fill: '#005da1'}, '<')
            .to('#ctem-svg .data-layer', {autoAlpha: .25}, '-=.5')
            .to('#ctem-svg .vendor-arrows', {autoAlpha: 0}, '<')
            .to('#ctem-svg .vendor-layer', {autoAlpha: .25}, '<')
            .to('#ctem-svg .firewall-layer', {autoAlpha: .25}, '<')
            .to('#ctem-svg .attack-layer', {autoAlpha: .25}, '<')
            .to('#ctem-svg .exposures-layer', {autoAlpha: .25}, '<')
            .to('#ctem-svg .security-line', {autoAlpha: .25}, '<')
            .to('#ctem-svg .remediation', {autoAlpha: 1})
            .to('#ctem-svg .real-env-icon-shadow', {fill: '#F37E47'}, '<')
            .to('#ctem-svg .real-env-icon-shadow', {fill: '#F37E47'}, '<');
    },

    transSummery() {
        //fade out remediation arrows and box
        //fade in security and vendor boxes
        return gsap.timeline({
            onComplete: () => {
                this.dsmLoopTl.play();
                this.attackLoopTl.play();
                this.realEnvLoopTlArray.map(tl => tl.play());
                this.remediationLoopTl.pause();
            }, onReverseComplete: () => {
                this.dsmLoopTl.pause();
                this.attackLoopTl.pause();
                this.realEnvLoopTlArray.map(tl => tl.pause());
                this.remediationLoopTl.play();
            },
        })
            .to('#ctem-svg .remediation', {autoAlpha: 0})
            .to('#ctem-svg .data-layer', {autoAlpha: 1}, '-=.5')
            .to('#ctem-svg .vendor-arrows', {autoAlpha: 1}, '<')
            .to('#ctem-svg .vendor-layer', {autoAlpha: 1}, '<')
            .to('#ctem-svg .firewall-layer', {autoAlpha: 1}, '<')
            .to('#ctem-svg .attack-layer', {autoAlpha: 1}, '<')
            .to('#ctem-svg .exposures-layer', {autoAlpha: 1}, '<')
            .to('#ctem-svg .security-line', {autoAlpha: 1}, '<')
            .add(this.grayscale($('#filter-real-env'), 1, 1), '-=.5')
            .add(this.grayscale($('#filter-real-env-icons'), 1, 1), '<')
            .add(this.grayscale($('#filter-data-layer'), 1, 1), '<')
            .add(this.grayscale($('#filter-vendor-arrows'), 1, 1), '<')
            .add(this.grayscale($('#filter-vendor-layer'), 1, 1), '<')
            .add(this.grayscale($('#filter-firewall-layer'), 1, 1), '<')
            .add(this.grayscale($('#filter-attack-layer'), 1, 1), '<')
            .add(this.grayscale($('#filter-exposures-layer'), 1, 1), '<')
            .add(this.grayscale($('#filter-security-line'), 1, 1), '<');
    },

    loopDSM() {
        const tl = gsap.timeline({repeat: -1});
        const speed = 3;
        $('#ctem-svg .dsm-circle-group').each((i, groupEl) => {
            const circles = $(groupEl).children();
            tl.to(circles[1], {
                attr: {rx: circles[1].rx.baseVal.value * 2, ry: circles[1].ry.baseVal.value * 2},
                transformOrigin: '50% 50%',
                duration: speed,
                ease: 'none',
            }, 0);
            tl.to(circles[2], {
                attr: {rx: circles[2].rx.baseVal.value * 2, ry: circles[2].ry.baseVal.value * 2},
                transformOrigin: '50% 50%',
                opacity: 1,
                duration: speed,
                ease: 'none',
            }, '<');
            tl.to(circles[0], {
                attr: {rx: circles[0].rx.baseVal.value * 2, ry: circles[0].ry.baseVal.value * 2},
                transformOrigin: '50% 50%',
                opacity: 0,
                duration: speed,
                ease: 'none',
            }, '<');
        });

        tl.to('#ctem-svg .threat-arrow', {strokeDashoffset: 18, duration: speed, ease: 'none'}, 0);
        return tl;
    },

    loopAttack() {
        const tl = gsap.timeline({repeat: -1});
        $('#ctem-svg .attack-line').each((i, el) => {
            tl.to(el, {opacity: 0, duration: .5});
            tl.set(el, {drawSVG: '0% 0%', opacity: 1});
            tl.to(el, {drawSVG: '0% 100%', duration: 4});
        });
        return tl;
    },

    loopFirewall() {
        const tl = gsap.timeline({repeat: -1});
        $('#firewall-fill stop').each((i, el) => {
            tl.fromTo(el, {attr: {offset: 0 + i + '%'}}, {
                attr: {offset: 50 + i + '%'}, duration: 6, ease: 'none',
            }, 0);
        });
        return tl;
    },

    loopRealEnv() {
        let timelines = [];
        $('#ctem-svg .real-env-icon-group').each((i, el) => {
            const tl = gsap.timeline({repeat: -1, yoyo: true});
            const icon = $(el).find('.real-env-icon')[0];
            const shadow = $(el).find('.real-env-icon-shadow')[0];
            tl.to(icon, {y: 4, duration: 3, ease: 'power2.in'});
            tl.to(shadow, {scale: .5, opacity: 1, transformOrigin: '50% 50%', duration: 3, ease: 'power1.in'}, 0);
            timelines.push(tl);
        });
        timelines.push(gsap.timeline({repeat: -1}).to('#ctem-svg .vendor-arrows line', {
            strokeDashoffset: 18, duration: 3, ease: 'none',
        }));
        return timelines;
    },

    loopRemediation() {
        const tl = gsap.timeline({repeat: -1});
        tl.from('#ctem-svg .remediation', {strokeDashoffset: 36, duration: 3, ease: 'none'}, 0);
        return tl;
    },
};
